/** Utah's words for howto.ts. */
export const HOWTO_UT = {
  /** Calibration step: no boiling-water method at Utah altitude (water boils below 212F). */
  boilingStep: "Don't use boiling water in Utah. Water boils below 212°F here.",
  /** Citation part: the sources give no boiling-point method in Utah. */
  noBoilingCite: "no boiling-point method in Utah",
} as const;
